import { gql } from "@apollo/client";

const sfdaMedicine = {
  GET_SFDA_MEDICINES: gql`
    query GetSfdaMedicines($page: Int, $limit: Int, $search: String) {
      getSfdaMedicines(page: $page, limit: $limit, search: $search) {
        medicines {
          id
          supergitMasterCode
          sfdaId
          registerNumber
          tradeName
          scientificName
          strength
          strengthUnit
          pharmaceuticalForm
          administrationRoute
          marketingCompany
          publicPrice
          marketingStatus
          authorizationStatus
          gtin
          drugType
          subType
          registerYear
          size
          sizeUnit
          packageTypes
          legalStatus
          productControl
          atcCode1
          atcCode2
          packageSize
          shelfLife
          storageConditions
          manufacturerName
          manufacturerCountry
          additionalManufacturer
          additionalManufacturerCountry
          companyCountryEn
          companyCountryAr
          legalStatusEn
          legalStatusAr
          domainEn
          domainAr
          imageUrl
          distributionArea
          drugCombinationsStrengthValue
          drugCombinationsScientificName
          drugCombinationsStrengthUnit
          descriptionCode
          productControlAr
          agent
          scientificCode
        }
        pageInfo {
          currentPage
          totalPages
          totalCount
          limit
        }
      }
    }
  `,

  GET_SFDA_MEDICINE: gql`
    query GetSfdaMedicine($id: ID!) {
      getSfdaMedicine(id: $id) {
        id
        supergitMasterCode
        sfdaId
        registerNumber
        registerYear
        gtin
        drugType
        subType
        scientificName
        tradeName
        strength
        strengthUnit
        pharmaceuticalForm
        administrationRoute
        size
        sizeUnit
        packageTypes
        legalStatus
        productControl
        publicPrice
        marketingCompany
        atcCode1
        atcCode2
        packageSize
        shelfLife
        storageConditions
        marketingStatus
        authorizationStatus
        manufacturerName
        manufacturerCountry
        additionalManufacturer
        additionalManufacturerCountry
        companyCountryEn
        companyCountryAr
        legalStatusEn
        legalStatusAr
        domainEn
        domainAr
        imageUrl
        distributionArea
        drugCombinationsStrengthValue
        drugCombinationsScientificName
        drugCombinationsStrengthUnit
        descriptionCode
        productControlAr
        agent
        scientificCode
      }
    }
  `,

  CREATE_SFDA_MEDICINE: gql`
    mutation CreateSfdaMedicine($input: SfdaMedicineInput!) {
      createSfdaMedicine(input: $input) {
        id
        supergitMasterCode
        registerNumber
        tradeName
        scientificName
        publicPrice
        marketingCompany
        scientificCode
      }
    }
  `,

  UPDATE_SFDA_MEDICINE: gql`
    mutation UpdateSfdaMedicine($id: ID!, $input: SfdaMedicineInput!) {
      updateSfdaMedicine(id: $id, input: $input) {
        id
        supergitMasterCode
        registerNumber
        tradeName
        scientificName
        publicPrice
        marketingCompany
        scientificCode
      }
    }
  `,

  DELETE_SFDA_MEDICINE: gql`
    mutation DeleteSfdaMedicine($id: ID!) {
      deleteSfdaMedicine(id: $id)
    }
  `,
};

export default sfdaMedicine;
